import * as rules from 'components/Input/validation';
import Modal from 'components/Shared/Modal';
import React, { useState } from 'react';
import { rm } from 'utils';
import { LoaderButton } from './NotifyMeButton';
import {
  DisclaimerWrapper,
  ErrorText,
  FormWrapper,
  StyledInput,
  StyledText
} from './notifyMe.styles';
import Markdown from 'components/Shared/Markdown';
import { useSendRequest, isValid } from './utils';

type NotifyModalProps = {
  show: boolean;
  onClose: () => void;
  onSuccess: () => void;
  productTitle: string;
};

export const NotifyMeModal = ({ show, onClose, onSuccess, productTitle }: NotifyModalProps) => {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [errorEmail, setErrorEmail] = useState<string | undefined>(undefined);
  const [errorPhone, setErrorPhone] = useState<string | undefined>(undefined);
  const [error, setError] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const disabledButton = !!error || !!errorEmail || !!errorPhone || email === '' || phone === '';

  const sendRequest = useSendRequest({ email, phone, productName: productTitle });

  const resetError = () => {
    if (error) {
      setError(undefined);
    }
  };

  const emailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    if (errorEmail) {
      setErrorEmail(undefined);
    }
    resetError();
  };

  const phoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPhone(e.target.value);
    if (errorPhone) {
      setErrorPhone(undefined);
    }
    resetError();
  };

  const handleSend = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    if (!isValid({ email, phone, setErrorEmail, setErrorPhone })) {
      setIsLoading(false);
      return;
    }
    sendRequest()
      .then(() => {
        handleClose();
        onSuccess();
        setIsLoading(false);
      })
      .catch(error => {
        setError(error.message[0]);
        setIsLoading(false);
      });
  };

  const handleClose = () => {
    setPhone('');
    setEmail('');
    setError(undefined);
    setErrorEmail(undefined);
    setErrorPhone(undefined);
    onClose();
  };

  const onBlurPhone = () => {
    const errorMessage = rules.phone(phone);
    if (errorMessage) {
      setErrorPhone(errorMessage);
    }
  };

  const onBlurEmail = () => {
    const errorMessage = rules.email(email);
    if (errorMessage) {
      setErrorEmail(errorMessage);
    }
  };

  return (
    <Modal show={show} onClose={handleClose}>
      <div>
        <h3>{rm('notify-me-header')}</h3>
        <h1>{productTitle}</h1>
      </div>
      <StyledText>{rm('notify-me-promt')}</StyledText>
      <FormWrapper onSubmit={handleSend}>
        <StyledInput
          type="phone"
          change={phoneChange}
          value={phone}
          placeholder={rm('customerpage_register_placeholder_phone')}
          rule={rules.phone}
          errorMessage={errorPhone}
          blur={onBlurPhone}
        />
        <StyledInput
          type="email"
          change={emailChange}
          value={email}
          placeholder={rm('Newsletter_Push_Email_Input')}
          rule={rules.email}
          errorMessage={errorEmail}
          blur={onBlurEmail}
        />
        <LoaderButton isLoading={isLoading} disabled={disabledButton} />
      </FormWrapper>
      {error && <ErrorText>{error}</ErrorText>}
      <DisclaimerWrapper>
        <Markdown tag="p" content={rm('notify-me-disclaimer')} />
      </DisclaimerWrapper>
    </Modal>
  );
};
